import { Navigate } from "react-router-dom";
import { useGlobal } from "../contexts/GlobalContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user, authLoading } = useGlobal();

  if (authLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/Login" replace />;
  }

  return children;
};

export default ProtectedRoute;
